import { useChains } from "@opensea/app-kit"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslations } from "use-intl"
import type { SwapFlowFormValues } from "../types"

export function useSwapButtonText() {
  const { getChain } = useChains()

  const t = useTranslations("wallet.useSwapButtonText")

  const { control } = useFormContext<SwapFlowFormValues>()

  const fromCurrency = useWatch({ control, name: "fromCurrency" })
  const toCurrency = useWatch({ control, name: "toCurrency" })

  const chain = getChain(fromCurrency.chainIdentifier)
  const toChain = toCurrency ? getChain(toCurrency.chainIdentifier) : undefined
  if (
    chain?.identifier === toChain?.identifier &&
    chain?.nativeCurrency &&
    chain.wrappedNativeCurrency
  ) {
    if (
      fromCurrency.contractAddress === chain.nativeCurrency.contractAddress &&
      toCurrency?.contractAddress ===
        chain.wrappedNativeCurrency.contractAddress
    ) {
      return t("wrap")
    }
    if (
      fromCurrency.contractAddress ===
        chain.wrappedNativeCurrency.contractAddress &&
      toCurrency?.contractAddress === chain.nativeCurrency.contractAddress
    ) {
      return t("unwrap")
    }
  }

  return t("swap")
}
